<template>
  <div :class="backTopClasses" :style="backTopStyles" @click="$_onBackTopClick">
    <slot v-if="$slots.default"></slot>
    <div v-else :class="backTopContent">
      <t-icon :icon="iconClass"></t-icon>
    </div>
  </div>
</template>
<script>
import { PREFIX_CLASS } from '../../utils/constants'
import { scrollTop } from '../../utils/assist'

const PREFIX_BACK_TOP_CLASS = `${PREFIX_CLASS}back-top`

export default {
  name: 'TBackTop',
  props: {
    // 显示偏移高度
    yOffset: {
      type: Number,
      default: 400
    },
    // 底边距
    bottom: {
      type: Number,
      default: 30
    },
    // 右边距
    right: {
      type: Number,
      default: 30
    },
    // 动画时长
    duration: {
      type: Number,
      default: 600
    }
  },
  data() {
    return {
      currentVisibled: false
    }
  },
  computed: {
    iconClass() {
      return `arrow-up-outline`
    },
    backTopClasses() {
      return [
        PREFIX_BACK_TOP_CLASS,
        {
          [`${PREFIX_BACK_TOP_CLASS}_visible`]: this.currentVisibled
        }
      ]
    },
    backTopContent() {
      return `${PREFIX_BACK_TOP_CLASS}__content`
    },
    backTopStyles() {
      return {
        bottom: `${this.bottom}px`,
        right: `${this.right}px`
      }
    }
  },
  mounted() {
    window.addEventListener('scroll', this.$_onScroll, false)
    window.addEventListener('resize', this.$_onScroll, false)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.$_onScroll, false)
    window.removeEventListener('resize', this.$_onScroll, false)
  },
  methods: {
    $_onScroll() {
      this.currentVisibled = window.pageYOffset >= this.yOffset
    },
    $_onBackTopClick() {
      const startPosition = document.documentElement.scrollTop || document.body.scrollTop
      scrollTop(window, startPosition, 0, this.duration)
      this.$emit('click')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/module/back-top/back-top.vue